module.exports = __webpack_public_path__ + "img/sv79on.5b9fde47.svg";